// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { StoresInstance } from "Globals/Stores";
import { IsEmail, IsNotEmpty, Equals, IsPhoneNumber } from "class-validator";
// Models

// Dto
import { NewApplicantRequestDTO } from "Globals/Models/DTO/NewApplicantRequestDTO";
import { RegistrationTypeEnum } from "Globals/Models/RegistrationTypeEnum";

export class NewApplicantRequestModel extends ModelBase<NewApplicantRequestModel, NewApplicantRequestDTO> {
    @IsNotEmpty({ message: "First name is required" })
    @MobX.observable
    public firstName: string = "";

    @IsNotEmpty({ message: "Surname is required" })
    @MobX.observable
    public surname: string = "";

    @IsPhoneNumber("GB", { message: "Phone number is not correct" })
    @MobX.observable
    public phoneNumber: string = "";

    @IsNotEmpty({ message: "Email address is required" })
    @IsEmail({}, { message: "Email address is not correct" })
    @MobX.observable
    public emailAddress: string = "";

    @MobX.observable public registrationType: RegistrationTypeEnum = RegistrationTypeEnum.DontSend;

    @MobX.action
    public fromDto = (model: NewApplicantRequestDTO): void => {
        if (model !== null && model !== undefined) {
            this.firstName = model.firstName;
            this.surname = model.surname;
            this.phoneNumber = model.phoneNumber;
            this.emailAddress = model.emailAddress;
            this.registrationType = model.registrationType;
        }
    };

    @MobX.action
    public toDto = (): NewApplicantRequestDTO => {
        let model: NewApplicantRequestDTO = {
            firstName: this.firstName,
            surname: this.surname,
            phoneNumber: this.phoneNumber,
            emailAddress: this.emailAddress,
            registrationType: this.registrationType,
        };
        return model;
    };
}
